// import React, { useState, useEffect, useCallback } from 'react';
// import { Plus, Edit2, Trash2, GripVertical, AlertCircle, Check, ChevronDown, ChevronUp, Building2 } from 'lucide-react';
// import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
// import { useNavigate } from 'react-router-dom';
// import StageForm from '../components/StagesComponents/StageForm';
// import DeleteConfirmModal from '../components/StagesComponents/DeleteConfirmModal';
// import api from '../common/apiClient';
// import SummaryApi from '../common/SummaryApi';
// import { FaArrowLeft } from 'react-icons/fa';
// import { MdAirplanemodeActive, MdAirplanemodeInactive } from "react-icons/md";
// const StageManagement = () => {
//   const navigate = useNavigate();
//   const [stages, setStages] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showForm, setShowForm] = useState(false);
//   const [editingStage, setEditingStage] = useState(null);
//   const [deleteModal, setDeleteModal] = useState({ show: false, stage: null });
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [expandedStages, setExpandedStages] = useState(new Set());
//   const [activeTab, setActiveTab] = useState('all');

//   // Fetch divisions
//   const fetchDivisions = async () => {
//     try {
//       const response = await api.get(SummaryApi.getAllDivisions.url);
//       if (response.data.success) {
//         setDivisions(response.data.data);
//       }
//     } catch (err) {
//       console.error('Failed to fetch divisions:', err);
//     }
//   };

//   const fetchStages = useCallback(async () => {
//     try {
//       setLoading(true);
//       const params = {
//         // includeInactive: false,
//         includeShared: true,
//       };

//       if (activeTab !== 'all') {
//         params.divisionId = activeTab;
//       }

//       const response = await api.get(SummaryApi.getAllStages.url, { params });
//       setStages(response.data.data);
//     } catch (err) {
//       console.error(err);
//       setError('Failed to load stages');
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab]);

//   useEffect(() => {
//     fetchStages();
//   }, [fetchStages]);

//   useEffect(() => {
//     fetchDivisions();
//   }, []);

//   const handleToggleStatus = async (stage) => {
//     await api.put(
//       SummaryApi.updateStage.url(stage._id),
//       {
//         isActive: !stage.isActive
//       }
//     );

//     fetchStages();
//   };

//   const toggleStageExpansion = (stageId) => {
//     setExpandedStages(prev => {
//       const newSet = new Set(prev);
//       if (newSet.has(stageId)) {
//         newSet.delete(stageId);
//       } else {
//         newSet.add(stageId);
//       }
//       return newSet;
//     });
//   };

//   const handleDragEnd = async (result) => {
//     if (!result.destination) return;

//     const items = Array.from(stages);
//     const [reorderedItem] = items.splice(result.source.index, 1);
//     items.splice(result.destination.index, 0, reorderedItem);

//     const updatedItems = items.map((item, index) => ({
//       ...item,
//       stageOrder: index + 1
//     }));

//     setStages(updatedItems);

//     try {
//       const stageOrders = updatedItems.map(item => ({
//         id: item._id,
//         order: item.stageOrder
//       }));

//       await api.post(SummaryApi.stageReorder.url, { stages: stageOrders });
//       setSuccess('Stages reordered successfully');
//     } catch (err) {
//       setError('Failed to reorder stages');
//       fetchStages();
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       await api.delete(SummaryApi.permanentDeleteStage.url(deleteModal.stage._id));
//       setSuccess('Stage deleted successfully');
//       setDeleteModal({ show: false, stage: null });
//       fetchStages();
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to delete stage');
//     }
//   };

//   const handleInitializeDefaults = async () => {
//     try {
//       await api.post(SummaryApi.initializeStages.url);
//       setSuccess('Default stages created successfully');
//       fetchStages();
//     } catch (err) {
//       setError('Failed to initialize default stages');
//     }
//   };

//   useEffect(() => {
//     if (success) {
//       const timer = setTimeout(() => setSuccess(''), 3000);
//       return () => clearTimeout(timer);
//     }
//   }, [success]);

//   useEffect(() => {
//     if (error) {
//       const timer = setTimeout(() => setError(''), 3000);
//       return () => clearTimeout(timer);
//     }
//   }, [error]);

//   const handleBackClick = () => {
//     navigate(-1);
//   };

//   // Fixed getDivisionBadges function
//   const getDivisionBadges = (stage) => {
//     if (!stage.divisionIds || stage.divisionIds.length === 0) {
//       return <span className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded">All Divisions</span>;
//     }
    
//     return stage.divisionIds.map(div => {
//       // Find the full division object from the divisions array
//       const divId = typeof div === 'string' ? div : div._id;
//       const fullDivision = divisions.find(d => d._id === divId);
      
//       return (
//         <span key={divId} className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded">
//           {fullDivision ? `${fullDivision.name} (${fullDivision.divisionId})` : 'Unknown Division'}
//         </span>
//       );
//     });
//   };

//   if (loading && stages.length === 0) {
//     return (
//       <div className="flex items-center justify-center min-h-[400px]">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="w-full p-4">
//       {/* Header */}
//       <div className="mb-4">
//         <div className="flex items-center gap-4 mb-2">
//           <button
//             onClick={handleBackClick}
//             className="mr-2 hover:bg-gray-300 rounded-full p-1"
//             title="Go back"
//           >
//             <FaArrowLeft className="h-5 w-5" />
//           </button>
//           <h1 className="text-2xl font-bold text-gray-900">Sales Pipeline Stages</h1>
//         </div>
//         <p className="text-gray-600 ml-11">Manage your sales process stages and pipeline flow</p>
//       </div>

//       {/* Alerts */}
//       {error && (
//         <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center">
//           <AlertCircle className="h-5 w-5 mr-2" />
//           {error}
//         </div>
//       )}

//       {success && (
//         <div className="mb-6 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg flex items-center">
//           <Check className="h-5 w-5 mr-2" />
//           {success}
//         </div>
//       )}

//       {/* Division Tabs */}
//       <div className="mb-6">
//         <div className="border-b border-gray-200">
//           <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
//             <button
//               onClick={() => setActiveTab('all')}
//               className={`
//                 whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors
//                 ${activeTab === 'all'
//                   ? 'border-red-500 text-red-600'
//                   : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//                 }
//               `}
//             >
//               All Stages
//             </button>
//             {divisions.map(division => (
//               <button
//                 key={division._id}
//                 onClick={() => setActiveTab(division._id)}
//                 className={`
//                   whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors flex items-center gap-2
//                   ${activeTab === division._id
//                     ? 'border-red-500 text-red-600'
//                     : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//                   }
//                 `}
//               >
//                 <Building2 className="h-4 w-4" />
//                 {division.name}
//               </button>
//             ))}
//           </nav>
//         </div>
//       </div>

//       {/* Actions Bar */}
//       <div className="flex justify-between items-center mb-6">
//         <div className="text-sm text-gray-500">
//           {activeTab === 'all' 
//             ? `Total Stages: ${stages.length}`
//             : `${divisions.find(d => d._id === activeTab)?.name || ''} Stages: ${stages.length}`
//           }
//         </div>

//         <div className="flex gap-3">
//           {stages.length === 0 && activeTab === 'all' && (
//             <button
//               onClick={handleInitializeDefaults}
//               className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
//             >
//               Initialize Default Stages
//             </button>
//           )}

//           <button
//             onClick={() => {
//               setEditingStage(null);
//               setShowForm(true);
//             }}
//             className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
//           >
//             <Plus className="h-5 w-5" />
//             Add Stage
//           </button>
//         </div>
//       </div>

//       {/* Stages List */}
//       <DragDropContext onDragEnd={handleDragEnd}>
//         <Droppable droppableId="stages">
//           {(provided) => (
//             <div
//               {...provided.droppableProps}
//               ref={provided.innerRef}
//               className="space-y-3"
//             >
//               {stages.map((stage, index) => {
//                 const isExpanded = expandedStages.has(stage._id);
                
//                 return (
//                   <Draggable
//                     key={stage._id}
//                     draggableId={stage._id}
//                     index={index}
//                   >
//                     {(provided, snapshot) => (
//                       <div
//                         ref={provided.innerRef}
//                         {...provided.draggableProps}
//                         className={`
//                           bg-white border rounded-lg p-4 
//                           ${snapshot.isDragging ? 'shadow-lg' : 'shadow-sm'}
//                           ${!stage.isActive ? 'opacity-60' : ''}
//                           transition-all
//                         `}
//                       >
//                         <div className="flex items-start gap-4">
//                           <div
//                             {...provided.dragHandleProps}
//                             className="cursor-move text-gray-400 hover:text-gray-600 mt-1"
//                           >
//                             <GripVertical className="h-5 w-5" />
//                           </div>

//                           <div className="flex-1">
//                             <div className="flex items-center gap-3 mb-2 flex-wrap">
//                               <div
//                                 className="w-3 h-3 rounded-full flex-shrink-0"
//                                 style={{ backgroundColor: stage.color }}
//                               />
//                               <h3 className="font-semibold text-gray-900">
//                                 {stage.stageName}
//                               </h3>
//                               <span className="text-sm text-gray-500">
//                                 ({stage.stageId})
//                               </span>
//                               <span className="text-sm px-2 py-1 bg-gray-100 rounded">
//                                 {stage.probability}%
//                               </span>
//                               <span className="text-sm px-2 py-1 bg-green-100 rounded">
//                                 Stage <span className='text-red-600'>{stage.orderSequence}</span>
//                               </span>
//                               {stage.isFinalStage && (
//                                 <span className="text-xs px-2 py-1 bg-red-100 text-red-700 rounded">
//                                   Final Stage
//                                 </span>
//                               )}
//                               {!stage.isActive && (
//                                 <span className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded">
//                                   Inactive
//                                 </span>
//                               )}
//                               <div className="flex gap-1 flex-wrap">
//                                 {getDivisionBadges(stage)}
//                               </div>
//                             </div>
                            
//                             {stage.activityGoal && (
//                               <p className="text-sm text-gray-600 mb-1">
//                                 <span className="font-medium">Goal:</span> {stage.activityGoal}
//                               </p>
//                             )}
                            
//                             {stage.exitCriteria && (
//                               <div className={`transition-all ${isExpanded ? 'mb-2' : ''}`}>
//                                 <button
//                                   onClick={() => toggleStageExpansion(stage._id)}
//                                   className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors"
//                                 >
//                                   {isExpanded ? (
//                                     <ChevronUp className="h-4 w-4" />
//                                   ) : (
//                                     <ChevronDown className="h-4 w-4" />
//                                   )}
//                                   <span>Exit Criteria</span>
//                                 </button>
//                                 {isExpanded && (
//                                   <p className="text-sm text-gray-600 mt-1 ml-5 p-2 bg-gray-50 rounded">
//                                     {stage.exitCriteria}
//                                   </p>
//                                 )}
//                               </div>
//                             )}
                            
//                             {stage.statistics && (
//                               <div className="flex gap-4 text-sm text-gray-500">
//                                 <span>Volume: {stage.statistics.count}</span>
//                                 <span>Value: ₹{stage.statistics.totalValue.toLocaleString()}</span>
//                               </div>
//                             )}
//                           </div>

//                           <div className="flex items-start gap-2">
//                             <button
//                               onClick={() => {
//                                 setEditingStage(stage);
//                                 setShowForm(true);
//                               }}
//                               className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
//                             >
//                               <Edit2 className="h-4 w-4" />
//                             </button>
//                             <button
//   onClick={() => handleToggleStatus(stage)}
//   className="p-2 rounded-lg hover:bg-gray-100"
// >
//   {stage.isActive ? (
//     <MdAirplanemodeActive className="text-green-600 text-xl" />
//   ) : (
//     <MdAirplanemodeInactive className="text-red-600 text-xl" />
//   )}
// </button>
//                             <button
//                               onClick={() => setDeleteModal({ show: true, stage })}
//                               disabled={stage.statistics?.count > 0}
//                               className={`
//                                 p-2 rounded-lg transition-colors
//                                 ${stage.statistics?.count > 0 
//                                   ? 'text-gray-300 cursor-not-allowed' 
//                                   : 'text-gray-600 hover:text-red-600 hover:bg-red-50'
//                                 }
//                               `}
//                               title={stage.statistics?.count > 0 ? 'Cannot delete - stage in use' : 'Delete stage'}
//                             >
//                               <Trash2 className="h-4 w-4" />
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </Draggable>
//                 );
//               })}
//               {provided.placeholder}
              
//               {stages.length === 0 && (
//                 <div className="text-center py-12 bg-gray-50 rounded-lg">
//                   <p className="text-gray-500">
//                     No stages found for {activeTab === 'all' ? 'this organization' : 'this division'}.
//                   </p>
//                 </div>
//               )}
//             </div>
//           )}
//         </Droppable>
//       </DragDropContext>

//       {/* Stage Form Modal */}
//       {showForm && (
//         <StageForm
//           stage={editingStage}
//           onClose={() => {
//             setShowForm(false);
//             setEditingStage(null);
//           }}
//           onSuccess={() => {
//             setShowForm(false);
//             setEditingStage(null);
//             fetchStages();
//           }}
//         />
//       )}

//       {/* Delete Confirmation */}
//       <DeleteConfirmModal
//         isOpen={deleteModal.show}
//         onClose={() => setDeleteModal({ show: false, stage: null })}
//         onConfirm={handleDelete}
//         title="Delete Stage"
//         message={`Are you sure you want to delete "${deleteModal.stage?.stageName}"? This action cannot be undone.`}
//       />
//     </div>
//   );
// };

// export default StageManagement;


import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
  Plus, Edit2, Trash2, GripVertical, AlertCircle, Check, 
  ChevronDown, ChevronUp, Building2, Search, X, RefreshCw, LayoutDashboard 
} from 'lucide-react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { useNavigate } from 'react-router-dom';
import StageForm from '../components/StagesComponents/StageForm';
import DeleteConfirmModal from '../components/StagesComponents/DeleteConfirmModal';
import SelectDropdown from '../customStyles/SelectDropdown';
import api from '../common/apiClient';
import SummaryApi from '../common/SummaryApi';
import { FaArrowLeft } from 'react-icons/fa';
import { MdAirplanemodeActive, MdAirplanemodeInactive } from "react-icons/md";

const StageManagement = () => {
  const navigate = useNavigate();
  const [stages, setStages] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [verticals, setVerticals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingStage, setEditingStage] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ show: false, stage: null });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [expandedStages, setExpandedStages] = useState(new Set());

  // Filters
  const [activeDivision, setActiveDivision] = useState('all');
  const [activeVertical, setActiveVertical] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const fetchFilterDependencies = async () => {
    try {
      const [divRes, vertRes] = await Promise.all([
        api.get(SummaryApi.getAllDivisions?.url),
        api.get(SummaryApi.getAllProducts?.url),
      ]);
      if (divRes.data?.success) setDivisions(divRes.data.data || []);
      if (vertRes.data?.success) setVerticals(vertRes.data.data || []);
    } catch (err) {
      console.error('Failed to fetch dependencies:', err);
    }
  };

  const fetchStages = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        includeInactive: true,
        includeShared: true,
      };

      if (activeDivision !== 'all') params.divisionId = activeDivision;
      if (activeVertical !== 'all') params.verticalId = activeVertical;

      const response = await api.get(SummaryApi.getAllStages.url, { params });
      setStages(response.data.data || []);
    } catch (err) {
      console.error(err);
      setError('Failed to load stages');
    } finally {
      setLoading(false);
    }
  }, [activeDivision, activeVertical]);

  useEffect(() => {
    fetchFilterDependencies();
  }, []);

  useEffect(() => {
    fetchStages();
  }, [fetchStages]);

  const availableVerticals = useMemo(() => {
    if (activeDivision === 'all') return verticals;
    return verticals.filter(v => (v.divisionId?._id || v.divisionId) === activeDivision);
  }, [verticals, activeDivision]);

  const handleDivisionChange = (divisionId) => {
    setActiveDivision(divisionId);
    setActiveVertical('all');
  };

  const filteredStages = useMemo(() => {
    return stages.filter((st) => {
      const matchSearch = 
        st.stageName?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
        st.stageId?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
        st.activityGoal?.toLowerCase().includes(searchTerm.toLowerCase().trim());

      const matchStatus = 
        statusFilter === 'all' ? true :
        statusFilter === 'active' ? st.isActive === true :
        st.isActive === false;

      return matchSearch && matchStatus;
    });
  }, [stages, searchTerm, statusFilter]);

  const handleToggleStatus = async (stage) => {
    try {
      const url = typeof SummaryApi.updateStage.url === 'function' ? SummaryApi.updateStage.url(stage._id) : SummaryApi.updateStage.url;
      await api.put(url, { isActive: !stage.isActive });
      fetchStages();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to toggle status');
    }
  };

  const toggleStageExpansion = (stageId) => {
    setExpandedStages(prev => {
      const newSet = new Set(prev);
      if (newSet.has(stageId)) newSet.delete(stageId);
      else newSet.add(stageId);
      return newSet;
    });
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const items = Array.from(filteredStages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    const updatedItems = items.map((item, index) => ({ ...item, orderSequence: index + 1 }));
    setStages(updatedItems);

    try {
      const stageOrders = updatedItems.map(item => ({ id: item._id, order: item.orderSequence }));
      await api.post(SummaryApi.stageReorder.url, { stages: stageOrders });
      setSuccess('Stages reordered successfully');
    } catch (err) {
      setError('Failed to reorder stages');
      fetchStages();
    }
  };

  const handleDelete = async () => {
    try {
      const url = typeof SummaryApi.permanentDeleteStage.url === 'function' ? SummaryApi.permanentDeleteStage.url(deleteModal.stage._id) : SummaryApi.permanentDeleteStage.url;
      await api.delete(url);
      setSuccess('Stage deleted successfully');
      setDeleteModal({ show: false, stage: null });
      fetchStages();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete stage');
    }
  };

  const handleInitializeDefaults = async () => {
    try {
      await api.post(SummaryApi.initializeStages.url);
      setSuccess('Default stages created successfully');
      fetchStages();
    } catch (err) {
      setError('Failed to initialize default stages');
    }
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const getDivisionBadges = (stage) => {
    if (!stage.divisionIds || stage.divisionIds.length === 0) {
      return <span className="text-[11px] px-2 py-0.5 bg-gray-100 text-gray-600 rounded">All Divisions</span>;
    }
    return stage.divisionIds.map(div => {
      const divId = typeof div === 'string' ? div : div._id;
      const full = divisions.find(d => d._id === divId) || div;
      return (
        <span key={divId} className="text-[11px] px-2 py-0.5 bg-blue-50 text-blue-700 border border-blue-200 rounded">
          {full.name || full.divisionName || 'Division'}
        </span>
      );
    });
  };

  const getVerticalBadges = (stage) => {
    if (!stage.verticalIds || stage.verticalIds.length === 0) {
      return <span className="text-[11px] px-2 py-0.5 bg-gray-100 text-gray-600 rounded">All Verticals</span>;
    }
    return stage.verticalIds.map(vert => {
      const vertId = typeof vert === 'string' ? vert : vert._id;
      const full = verticals.find(v => v._id === vertId) || vert;
      return (
        <span key={vertId} className="text-[11px] px-2 py-0.5 bg-purple-50 text-purple-700 border border-purple-200 rounded">
          {full.name || 'Vertical'}
        </span>
      );
    });
  };

  return (
    <div className="w-full p-4">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors" title="Back">
            <FaArrowLeft className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-gray-900">Sales Pipeline Stages</h1>
            <p className="text-xs md:text-sm text-gray-500">Configure workflow stages, division/vertical mapping, and dashboard metrics</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {stages.length === 0 && activeDivision === 'all' && (
            <button onClick={handleInitializeDefaults} className="px-3.5 py-2 text-xs md:text-sm font-medium bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition-colors">
              Initialize Defaults
            </button>
          )}
          <button
            onClick={() => { setEditingStage(null); setShowForm(true); }}
            className="flex items-center gap-1.5 px-4 py-2 bg-red-600 text-white rounded-lg text-xs md:text-sm font-medium hover:bg-red-700 transition-colors shadow-sm"
          >
            <Plus className="h-4 w-4" />
            <span>Add Stage</span>
          </button>
        </div>
      </div>

      {/* Notifications */}
      {error && (
        <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-2.5 rounded-lg flex items-center text-sm">
          <AlertCircle className="h-4 w-4 mr-2 shrink-0" />
          <span>{error}</span>
        </div>
      )}
      {success && (
        <div className="mb-4 bg-green-50 border border-green-200 text-green-700 px-4 py-2.5 rounded-lg flex items-center text-sm">
          <Check className="h-4 w-4 mr-2 shrink-0" />
          <span>{success}</span>
        </div>
      )}

      {/* Division Navigation Tabs */}
      <div className="mb-4 border-b border-gray-200">
        <nav className="-mb-px flex space-x-6 overflow-x-auto no-scrollbar" aria-label="Tabs">
          <button
            onClick={() => handleDivisionChange('all')}
            className={`whitespace-nowrap pb-2.5 px-1 border-b-2 font-medium text-xs md:text-sm transition-colors ${
              activeDivision === 'all' ? 'border-red-600 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            All Divisions
          </button>
          {divisions.map(division => (
            <button
              key={division._id}
              onClick={() => handleDivisionChange(division._id)}
              className={`whitespace-nowrap pb-2.5 px-1 border-b-2 font-medium text-xs md:text-sm transition-colors flex items-center gap-1.5 ${
                activeDivision === division._id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <Building2 className="h-3.5 w-3.5" />
              <span>{division.name}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Filter & Search Bar with SelectDropdown */}
      <div className="bg-white p-3.5 rounded-xl border border-gray-200 mb-5 flex flex-col md:flex-row gap-3 items-center justify-between">
        <div className="relative w-full md:w-72">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search by stage name, ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-9 pr-8 py-2 text-xs md:text-sm bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:bg-white"
          />
          {searchTerm && (
            <button onClick={() => setSearchTerm('')} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-2.5 w-full md:w-auto">
          {/* Vertical Dropdown */}
          <div className="w-full sm:w-48">
            <SelectDropdown
              options={[
                { _id: 'all', name: 'All Verticals' },
                ...availableVerticals
              ]}
              value={activeVertical}
              onChange={(val) => setActiveVertical(val)}
              placeholder="Select Vertical"
              valueKey="_id"
              labelKey="name"
              searchable={true}
              className="w-full"
            />
          </div>

          {/* Status Dropdown */}
          <div className="w-full sm:w-36">
            <SelectDropdown
              options={[
                { value: 'all', label: 'All Status' },
                { value: 'active', label: 'Active Only' },
                { value: 'inactive', label: 'Inactive Only' },
              ]}
              value={statusFilter}
              onChange={(val) => setStatusFilter(val)}
              placeholder="Select Status"
              valueKey="value"
              labelKey="label"
              searchable={false}
              className="w-full"
            />
          </div>

          <button
            onClick={() => { fetchFilterDependencies(); fetchStages(); }}
            disabled={loading}
            className="p-2 border border-gray-300 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
            title="Refresh"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
          </button>
        </div>
      </div>

      {/* Stage Count Overview */}
      <div className="flex justify-between items-center text-xs text-gray-500 mb-3 px-1">
        <span>Showing {filteredStages.length} of {stages.length} stages</span>
        <span>Drag using handle to reorder pipeline sequence</span>
      </div>

      {/* Stages Reorderable List */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="stages">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef} className="space-y-3">
              {filteredStages.map((stage, index) => {
                const isExpanded = expandedStages.has(stage._id);
                const cfg = stage.dashboardConfig || {};

                return (
                  <Draggable key={stage._id} draggableId={stage._id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`bg-white border rounded-xl p-4 transition-all ${
                          snapshot.isDragging ? 'shadow-lg border-red-300' : 'shadow-xs border-gray-200'
                        } ${!stage.isActive ? 'opacity-65 bg-gray-50/70' : ''}`}
                      >
                        <div className="flex items-start gap-3">
                          <div {...provided.dragHandleProps} className="cursor-grab text-gray-400 hover:text-gray-700 mt-1">
                            <GripVertical className="h-5 w-5" />
                          </div>

                          <div className="flex-1 min-w-0">
                            {/* Main Stage Details */}
                            <div className="flex items-center gap-2.5 mb-2 flex-wrap">
                              <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: stage.color }} />
                              <h3 className="font-bold text-sm md:text-base text-gray-900">{stage.stageName}</h3>
                              <span className="font-mono text-xs text-gray-500 font-semibold">({stage.stageId})</span>

                              <span className="text-[11px] px-2 py-0.5 bg-gray-100 font-semibold rounded text-gray-700">
                                Order #{stage.orderSequence}
                              </span>

                              {/* Lead Share %: Always visible with true percentage */}
                              <span className="text-[11px] px-2 py-0.5 bg-blue-50 text-blue-700 font-semibold border border-blue-200 rounded">
                                {stage.statistics?.percentage ?? 0}% Leads
                              </span>

                              <span className="text-[11px] px-2 py-0.5 bg-emerald-50 text-emerald-700 font-semibold border border-emerald-200 rounded">
                                {stage.probability}% Win Rate
                              </span>

                              {stage.isFinalStage && (
                                <span className="text-[10px] px-2 py-0.5 bg-red-100 text-red-700 font-bold rounded uppercase">
                                  Final Stage
                                </span>
                              )}
                              {!stage.isActive && (
                                <span className="text-[10px] px-2 py-0.5 bg-gray-200 text-gray-700 rounded font-bold">
                                  Inactive
                                </span>
                              )}
                            </div>

                            {/* Assigned Badges */}
                            <div className="flex items-center gap-1.5 flex-wrap mb-2.5">
                              <div className="flex items-center gap-1">{getDivisionBadges(stage)}</div>
                              <div className="flex items-center gap-1">{getVerticalBadges(stage)}</div>
                            </div>

                            {/* Goal & Exit Criteria */}
                            {stage.activityGoal && (
                              <p className="text-xs text-gray-600 mb-1">
                                <span className="font-semibold text-gray-700">Goal:</span> {stage.activityGoal}
                              </p>
                            )}
                            {stage.exitCriteria && (
                              <div className="mb-2">
                                <button
                                  onClick={() => toggleStageExpansion(stage._id)}
                                  className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 transition-colors"
                                >
                                  {isExpanded ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
                                  <span>Exit Criteria</span>
                                </button>
                                {isExpanded && (
                                  <p className="text-xs text-gray-600 mt-1 p-2 bg-gray-50 border border-gray-100 rounded-lg">
                                    {stage.exitCriteria}
                                  </p>
                                )}
                              </div>
                            )}

                            {/* Real Statistics: Volume, Value and Quotes ALWAYS Shown */}
                            <div className="flex flex-wrap items-center justify-between gap-3 pt-2 border-t border-gray-100 text-xs">
                              <div className="flex items-center gap-4 text-gray-700 font-medium">
                                <span>Volume: <strong className="text-gray-900">{stage.statistics?.count ?? 0}</strong></span>
                                <span>Value: <strong className="text-gray-900">₹{(stage.statistics?.totalValue || 0).toLocaleString()}</strong></span>
                                <span>Quotes: <strong className="text-gray-900">{stage.statistics?.totalQuotations ?? 0}</strong></span>
                              </div>

                              {/* Dashboard Config Badges: Visual indicator only */}
                              <div className="flex items-center gap-1.5 text-[11px] text-gray-500">
                                <LayoutDashboard className="w-3.5 h-3.5 text-gray-400" />
                                <span className="text-[10px] text-gray-400 uppercase font-semibold">Cards:</span>
                                {cfg.showLeadCount !== false && <span className="px-1.5 py-0.2 bg-gray-100 rounded text-gray-600">Leads</span>}
                                {cfg.showRevenue !== false && <span className="px-1.5 py-0.2 bg-gray-100 rounded text-gray-600">Revenue</span>}
                                {cfg.showPercentage !== false && <span className="px-1.5 py-0.2 bg-gray-100 rounded text-gray-600">Stage %</span>}
                                {cfg.showQuotation && <span className="px-1.5 py-0.2 bg-gray-100 rounded text-gray-600">Quotes</span>}
                              </div>
                            </div>
                          </div>

                          {/* Actions */}
                          <div className="flex items-center gap-1 shrink-0">
                            <button
                              onClick={() => { setEditingStage(stage); setShowForm(true); }}
                              className="p-1.5 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                              title="Edit Stage"
                            >
                              <Edit2 className="h-4 w-4" />
                            </button>
                            <button
                              onClick={() => handleToggleStatus(stage)}
                              className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
                              title={stage.isActive ? 'Deactivate' : 'Activate'}
                            >
                              {stage.isActive ? (
                                <MdAirplanemodeActive className="text-green-600 text-lg" />
                              ) : (
                                <MdAirplanemodeInactive className="text-red-500 text-lg" />
                              )}
                            </button>
                            <button
                              onClick={() => setDeleteModal({ show: true, stage })}
                              disabled={stage.statistics?.count > 0}
                              className={`p-1.5 rounded-lg transition-colors ${
                                stage.statistics?.count > 0 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-red-600 hover:bg-red-50'
                              }`}
                              title={stage.statistics?.count > 0 ? 'Cannot delete - stage in use' : 'Delete stage'}
                            >
                              <Trash2 className="h-4 w-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}

              {filteredStages.length === 0 && (
                <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
                  <p className="text-sm font-medium text-gray-600">No stages found matching the selected criteria.</p>
                  <p className="text-xs text-gray-400 mt-1">Try switching division/vertical or click "Add Stage".</p>
                </div>
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {/* Stage Drawer Modal */}
      {showForm && (
        <StageForm
          stage={editingStage}
          onClose={() => { setShowForm(false); setEditingStage(null); }}
          onSuccess={() => { setShowForm(false); setEditingStage(null); fetchStages(); }}
        />
      )}

      {/* Delete Confirmation */}
      <DeleteConfirmModal
        isOpen={deleteModal.show}
        onClose={() => setDeleteModal({ show: false, stage: null })}
        onConfirm={handleDelete}
        title="Delete Stage"
        message={`Are you sure you want to delete "${deleteModal.stage?.stageName}"? This action cannot be undone.`}
      />
    </div>
  );
};

export default StageManagement;